module.exports = __webpack_public_path__ + "static/media/reneAlfaro.31c044d1.jpg";